import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Fixed-to-viewport-bottom icon+label tab bar for touch-first, shopper-facing chrome
 * (`ecommerce-store`, the marketplace `/store` subtree, the POS till) — the counterpart
 * to `MobileDrawerNav` for admin/back-office chrome. Honors the iOS home-indicator safe
 * area via `env(safe-area-inset-bottom)` (see `.sl-bottom-tab-bar` in styles.css) and
 * respects `--sl-touch-target-min` for each tab's minimum hit area.
 */
export function BottomTabBar({ items, activeKey, onNavigate }) {
    return (_jsx("nav", { className: "sl-bottom-tab-bar", "aria-label": "Primary", children: items.map((item) => {
            const active = item.key === activeKey;
            const badgeLabel = item.badge && item.badge > 0 ? (item.badge > 99 ? "99+" : String(item.badge)) : null;
            return (_jsxs("a", { href: item.href, "data-tab-key": item.key, className: ["sl-bottom-tab-bar__tab", active ? "sl-bottom-tab-bar__tab--active" : null].filter(Boolean).join(" "), "aria-current": active ? "page" : undefined, onClick: (event) => {
                    if (onNavigate) {
                        event.preventDefault();
                        onNavigate(item);
                    }
                }, children: [_jsxs("span", { className: "sl-bottom-tab-bar__icon", children: [item.icon, badgeLabel ? _jsx("span", { className: "sl-bottom-tab-bar__badge", children: badgeLabel }) : null] }), _jsx("span", { className: "sl-bottom-tab-bar__label", children: item.label })] }, item.key));
        }) }));
}
//# sourceMappingURL=BottomTabBar.js.map